import { Controller } from "@hotwired/stimulus";
export default class extends Controller {

  handleSelectItem({ target }) {
    if (this.element.dataset.value == target.dataset.value) {
      this.element.setAttribute("aria-selected", true);
      // Also set aria-selected on the SVG icon
      const svg = this.element.querySelector("svg");
      if (svg) svg.setAttribute("aria-selected", "true");
    } else {
      this.element.removeAttribute("aria-selected");
      // Remove aria-selected from the SVG icon
      const svg = this.element.querySelector("svg");
      if (svg) svg.removeAttribute("aria-selected");
    }
  }
}
